import { ButtonHTMLAttributes, PropsWithChildren } from 'react';
import './ActionIcon.styles.less';
import classNames from 'classnames';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  size?: number;
  radius?: number;
};

const ActionIcon: React.FC<PropsWithChildren<Props>> = ({
  size,
  radius,
  ...props
}) => {
  return (
    <div className="action-icon-wrapper" data-disabled={props.disabled}>
      <button
        {...props}
        className={classNames('action-icon-root', props.className)}
        style={{
          width: size,
          height: size,
          borderRadius: radius,
          ...props.style,
        }}
      />
    </div>
  );
};

export default ActionIcon;
